class Criteria
	@setId: 0

	constructor: (property, comparator, value, setLogical) ->
		@criterias = []

		@add property, comparator, value, undefined, setLogical

	and: (property, comparator, value) ->
		@add property, comparator, value, 'AND'

	or: (property, comparator, value) ->
		@add property, comparator, value, 'OR'

	xor: (property, comparator, value) ->
		@add property, comparator, value, 'XOR'

	add: (property, comparator, value, logical, setLogical) ->
		if @criterias.length == 1
			@set = Criteria.pullId()
			@criterias[0].set = @set

		criteria =
			property: property
			comparator: comparator
			value: value

		if @set
			criteria.set = @set

		if logical?
			criteria.logical = logical.toUpperCase()

		if setLogical?
			criteria.set_logical = setLogical.toUpperCase()

		@criterias.push criteria

		return @

	@pullId: ->

		return 'SET_' + (Criteria.setId++)
